import {
  type CreateMultipartUploadOptions,
  createMultipartUpload as createSharedMultipartUpload,
  type MultipartUploadHandle,
} from "@vericus/cadmus-media-upload";

import * as config from "@/config";

import { lecturerHeaders } from "./headers";

export type {
  CreateMultipartUploadOptions,
  MultipartUploadHandle,
  UploadedMedia as MediaData,
} from "@vericus/cadmus-media-upload";

/**
 * Athena resource uploads via the shared multipart helper (avoids the 504 a
 * single large-file CloudFront PUT hits), injecting the assessment context.
 */
export function createMultipartUpload(
  file: File,
  assessmentId: string,
  opts: CreateMultipartUploadOptions = {}
): MultipartUploadHandle {
  return createSharedMultipartUpload({
    file,
    onProgress: opts.onProgress,
    apiEndpoint: config.API_ENDPOINT,
    assessmentId,
    createHeaders: lecturerHeaders,
  });
}
